module.exports = __webpack_public_path__ + "img/menu-artwork.7ab23d99.png";